(function () {
"use strict";

function getVideoId(href) {
if (!href) return null;
var shorts = href.match(/youtube\.com\/shorts\/([\w-]+)/);
if (shorts) return shorts[1];
var watch = href.match(/[?&]v=([\w-]+)/);
if (watch) return watch[1];
var short = href.match(/youtu\.be\/([\w-]+)/);
if (short) return short[1];
return null;
}

function initCarousel(track) {
var wrap = track.parentElement;
var nav = wrap ? wrap.querySelector(".hq-carnav") : null;
var slides = Array.prototype.slice.call(track.querySelectorAll(".hq-carslide"));
var timer = null;
var interacted = false;

function step() {
var first = slides[0];
var w = first ? first.getBoundingClientRect().width : track.clientWidth;
return w + 12;
}

function scrollDir(dir) {
track.scrollBy({ left: dir * step(), behavior: "auto" });
}

function stopAuto() {
interacted = true;
if (timer) {
clearInterval(timer);
timer = null;
}
}

function startAuto() {
if (interacted || slides.length < 2) return;
timer = setInterval(function () {
var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
if (atEnd) {
track.scrollTo({ left: 0, behavior: "auto" });
} else {
scrollDir(1);
}
}, 4500);
}

if (nav) {
var buttons = nav.querySelectorAll("button");
if (buttons[0]) {
buttons[0].setAttribute("aria-label", "Previous video");
buttons[0].addEventListener("click", function () {
stopAuto();
scrollDir(-1);
});
}
if (buttons[1]) {
buttons[1].setAttribute("aria-label", "Next video");
buttons[1].addEventListener("click", function () {
stopAuto();
scrollDir(1);
});
}
}

["pointerdown", "wheel", "touchstart"].forEach(function (evt) {
track.addEventListener(evt, stopAuto, { passive: true });
});

slides.forEach(function (slide) {
slide.addEventListener("click", function (e) {
if (slide.querySelector("iframe")) return;
var videoId = getVideoId(slide.getAttribute("href"));
if (!videoId) return;
e.preventDefault();
stopAuto();
var iframe = document.createElement("iframe");
iframe.src = "https://www.youtube-nocookie.com/embed/" + videoId + "?autoplay=1&playsinline=1";
iframe.setAttribute("allow", "autoplay; encrypted-media; picture-in-picture");
iframe.setAttribute("allowfullscreen", "");
iframe.setAttribute("title", slide.getAttribute("alt") || "Hamuq video");
iframe.style.position = "absolute";
iframe.style.inset = "0";
iframe.style.width = "100%";
iframe.style.height = "100%";
iframe.style.border = "0";
slide.innerHTML = "";
slide.appendChild(iframe);
});
});

startAuto();
}

function init() {
var tracks = document.querySelectorAll(".hq-cartrack");
tracks.forEach(function (track) {
initCarousel(track);
});
}

if (document.readyState === "loading") {
document.addEventListener("DOMContentLoaded", init);
} else {
init();
}
})();
